const isEmpty = (object: unknown) => {
  const objectString = JSON.stringify(object);
  return objectString == '{}' || objectString == '';
};

export default isEmpty;
